import { Link } from "react-router-dom";
import { RunningProjectInfo } from "providers/HostedScrapingProvider/types";
import { JobInfoBox } from "components/hosted-scraping/job-list/JobInfoBox";

export const JobQueuedInfo = ({projectId, runningProjectInfo}: {projectId: number, runningProjectInfo: RunningProjectInfo | undefined}) => {

  if (runningProjectInfo === undefined || runningProjectInfo.runningProjectId === null) {
    return null;
  }

  // The list is in ascending order, so the first one is the one that will run next
  const amIRunningNext = runningProjectInfo.futureProjects.length === 0
    || (runningProjectInfo.futureProjects.length > 0 && runningProjectInfo.futureProjects[0].projectId === projectId);

  return (
    <JobInfoBox bgColor="bg-warning-50" borderColor="border-warning-200" className="flex-col items-start">
      <div className="font-medium text-sm">
        You have a <Link className='text-primary-600 hover:underline' to={`/projects/${runningProjectInfo.runningProjectId}`}>running job</Link>.
      </div>
      { amIRunningNext && (
        <div className="text-xs">This job will start as soon as the currently running job is finished.</div>
      )}
      { !amIRunningNext && (
        <div className="text-xs">There are other jobs waiting in the queue.</div>
      )}
    </JobInfoBox>
  );
};
